import { render, staticRenderFns } from "./PurchasedMembership.vue?vue&type=template&id=2ab12369&scoped=true"
import script from "./PurchasedMembership.vue?vue&type=script&lang=ts"
export * from "./PurchasedMembership.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab12369",
  null
  
)

export default component.exports